// extracted by mini-css-extract-plugin
module.exports = {"signature":"persetujuan_signature_r1jPX","custom-button-yes":"persetujuan_custom-button-yes_3Vt44","buttons":"persetujuan_buttons_2q6pb"};